// removed by extract-text-webpack-plugin
module.exports = {"container":"SuccessMessage__container___6Obk6"};